import Api from "@/services/AxiosAPI";
export default {
  checkout(cart, user) {
    var myJSON = JSON.stringify(cart);
    const form = new FormData();
    form.append("cart", myJSON);
    form.append("user", user);

    return Api.postData('/orders', form)
      .then(response => {
        return response
      });
  },
  checkoutprocess(user, userid) {
    return Api.postData('/user/' + userid, {
      'first_name': user.first_name, 'first_name': user.first_name,
      'last_name': user.last_name, 'address_1': user.address_1, 'address_2': user.address_2, 'address_3': user.address_3,
      'address_4': user.address_4, 'town': user.town, 'country_id': user.country_id, 'postcode': user.postcode, 'mobile_phone': user.mobile_phone,
      'phone': user.phone, 'company_name': user.company_name, 'county': user.county, 'subscription': user.subscription, 'courtesy_title': user.courtesy_title,
      'fax': user.fax
    })
    .then(response => {
      return response
    });
  }
}